class PickAndMixApp extends HTMLElement {
  constructor() {
    super();

    this.bundleConfig = {
      '5-1': {
        handle: this.getAttribute('data-bundle-5-1-handle'),
        target: parseInt(this.getAttribute('data-bundle-5-1-target'), 10),
        free: parseInt(this.getAttribute('data-bundle-5-1-free'), 10),
      },
      '8-4': {
        handle: this.getAttribute('data-bundle-8-4-handle'),
        target: parseInt(this.getAttribute('data-bundle-8-4-target'), 10),
        free: parseInt(this.getAttribute('data-bundle-8-4-free'), 10),
      },
    };

    const priceScript = this.querySelector('[data-bundle-prices]');
    this.priceData = priceScript ? JSON.parse(priceScript.textContent) : {};

    this.state = {
      bundle: '5-1',
      size: '50x100',
      quantities: {}, // colorName -> qty
    };

    this.pendingBundleKey = null;
  }

  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
// Read dynamic multi-lingual translations passed from Liquid
    this.translations = {
      of: this.getAttribute('data-t-of') || 'of',
      subtotal: this.getAttribute('data-t-subtotal') || 'Subtotaal',
      total: this.getAttribute('data-t-total') || 'Totaal',
      addToCart: this.getAttribute('data-t-add-to-cart') || 'In winkelwagen',
      adding: this.getAttribute('data-t-adding') || 'Toevoegen...',
      added: this.getAttribute('data-t-added') || 'Toegevoegd!',
      free: this.getAttribute('data-t-free') || 'gratis',
      remainingHint: this.getAttribute('data-t-remaining-hint') || 'Nog [COUNT] om je set compleet te maken',
      remainingUnits: {
        '50x100': {
          singular: this.getAttribute('data-t-remaining-unit-50x100-singular') || 'handdoek',
          plural: this.getAttribute('data-t-remaining-unit-50x100-plural') || 'handdoeken',
        },
        '70x140': {
          singular: this.getAttribute('data-t-remaining-unit-70x140-singular') || 'badlaken',
          plural: this.getAttribute('data-t-remaining-unit-70x140-plural') || 'badlakens',
        },
      },
      completeHint: this.getAttribute('data-t-complete-hint') || 'Je set is compleet!',
      errorMsg: this.getAttribute('data-t-error-msg') || 'Er ging iets mis. Probeer het opnieuw.',
      removeItems: this.getAttribute('data-t-remove-items') || 'Verwijder items handmatig',
      startOver: this.getAttribute('data-t-start-over') || 'Opnieuw beginnen',
      bundleWarning: this.getAttribute('data-t-bundle-warning') || 'Je hebt meer dan [TARGET] handdoeken geselecteerd. Verwijder overtollige items handmatig of begin opnieuw.'
    };
    this.bundleToggleEl = this.querySelector('[data-bundle-toggle]');
    this.sizeToggleEl = this.querySelector('[data-size-toggle]');
    this.colorGridEl = this.querySelector('[data-color-grid]');
    this.progressBarEl = this.querySelector('[data-progress-bar]');
    this.progressCountEl = this.querySelector('[data-progress-count]');
    this.progressHintEl = this.querySelector('[data-progress-hint]');
    this.stickySentinelEl = this.querySelector('[data-sticky-sentinel]');
    this.progressHolderEl = this.querySelector('[data-progress-holder]');
    this.bundleWarningEl = this.querySelector('[data-bundle-warning]');
    this.bundleWarningMessageEl = this.querySelector('[data-bundle-warning-message]');
    this.bundleWarningDismissBtn = this.querySelector('[data-bundle-warning-dismiss]');
    this.bundleWarningStartOverBtn = this.querySelector('[data-bundle-warning-startover]');
    this.hintRemainingEl = this.querySelector('[data-hint-remaining]');
    this.summaryEl = this.querySelector('[data-summary]');
    this.summaryLinesEl = this.querySelector('[data-summary-lines]');
    this.summarySubtotalEl = this.querySelector('[data-summary-subtotal]');
    this.summaryDiscountRowEl = this.querySelector('[data-summary-discount-row]');
    this.summaryDiscountLabelEl = this.querySelector('[data-summary-discount-label]');
    this.summaryDiscountValueEl = this.querySelector('[data-summary-discount-value]');
    this.summaryTotalEl = this.querySelector('[data-summary-total]');
    this.summaryTotalCompareEl = this.querySelector('[data-summary-total-compare]');
    this.addToCartBtn = this.querySelector('[data-add-to-cart]');
    this.addToCartText = this.querySelector('[data-add-to-cart-text]');
    this.addToCartSpinner = this.querySelector('[data-add-to-cart-spinner]');
    this.errorHolder = this.querySelector('[data-pick-mix-error-holder]');
    this.errorMessage = this.querySelector('[data-pick-mix-error-message]');

    this.colorItems = Array.from(this.querySelectorAll('[data-color-item]'));
    this.mobileDrawer = null
    this.colorItems.forEach((item) => {
      const name = item.getAttribute('data-color-name');
      this.state.quantities[name] = 0;
    });

   this.buildProgressSegments();
    this.bindEvents();
    this.render();
    this.setupStickyObserver();
    this.updateDynamicDiscountLabels(); // Recalculate badge discount on load
    this.updateBundleLabels('5-1');
    this.updateBundleLabels('8-4');
    // Force-open the mobile stepper drawer below the active row on initial page reload
    // Force-open the mobile stepper drawer below the active row on initial page reload
    const activeItem = this.querySelector('[data-color-item].is-active') || this.colorItems[0];
    if (activeItem && window.innerWidth < 1024) {
      const name = activeItem.getAttribute('data-color-name');
      this.openMobileDrawer(activeItem, name);
    }
  }

  bindEvents() {
    console.log('[DEBUG] bindEvents() called on element:', this);
    this.bundleToggleEl.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-bundle-option]');
      if (!btn || btn.classList.contains('is-active')) return;
      this.attemptSwitchBundle(btn.getAttribute('data-bundle-option'));
    });

    this.sizeToggleEl.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-size-option]');
      if (!btn || btn.classList.contains('is-active')) return;
      this.switchSize(btn.getAttribute('data-size-option'));
    });

    this.colorItems.forEach((item) => {
      const name = item.getAttribute('data-color-name');
      const minusBtn = item.querySelector('[data-stepper-minus]');
      const plusBtn = item.querySelector('[data-stepper-plus]');

      minusBtn.addEventListener('click', () => this.changeQuantity(name, -1));
      plusBtn.addEventListener('click', () => this.changeQuantity(name, 1));

      item.addEventListener('click', (e) => {
        if (e.target.closest('[data-stepper-minus], [data-stepper-plus]')) return;
        if (window.innerWidth < 1024) {
          this.openMobileDrawer(item, name);
        }
      });
    });

    this.addToCartBtn.addEventListener('click', () => this.addToCart());

    if (this.bundleWarningDismissBtn) {
      this.bundleWarningDismissBtn.addEventListener('click', () => this.hideBundleWarning());
    }
    if (this.bundleWarningStartOverBtn) {
      this.bundleWarningStartOverBtn.addEventListener('click', () => {
        const key = this.pendingBundleKey;
        this.hideBundleWarning();
        if (key) {
          this.resetQuantities();
          this.switchBundle(key);
        }
      });
    }
  }
  openMobileDrawer(item, name) {
    if (this.mobileDrawer) {
      this.mobileDrawer.remove();
      this.mobileDrawer = null;
    }

    this.colorItems.forEach(c => c.classList.remove('is-active'));
    item.classList.add('is-active');

    const drawer = document.createElement('div');
    drawer.className = 'pick-and-mix__mobile-stepper-drawer';
    drawer.innerHTML = `
      <span class="drawer-color-name">${name}</span>
      <div class="drawer-stepper">
        <button type="button" class="drawer-stepper-btn" data-drawer-minus aria-label="Verlaag aantal">
          <svg width="20" height="20" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M23 16L9 16" stroke="#373737" stroke-width="1.2" stroke-linecap="round"/>
          </svg>
        </button>
        <span class="drawer-stepper-value">${this.state.quantities[name]}</span>
        <button type="button" class="drawer-stepper-btn" data-drawer-plus aria-label="Verhoog aantal">
          <svg width="20" height="20" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16 9L16 23M23 16L9 16" stroke="#373737" stroke-width="1.2" stroke-linecap="round"/>
          </svg>
        </button>
      </div>
    `;

    drawer.querySelector('[data-drawer-minus]').addEventListener('click', (e) => {
      e.stopPropagation();
      this.changeQuantity(name, -1);
      drawer.querySelector('.drawer-stepper-value').textContent = this.state.quantities[name];
      this.updateDrawerButtons(drawer, name);
    });

    drawer.querySelector('[data-drawer-plus]').addEventListener('click', (e) => {
      e.stopPropagation();
      this.changeQuantity(name, 1);
      drawer.querySelector('.drawer-stepper-value').textContent = this.state.quantities[name];
      this.updateDrawerButtons(drawer, name);
    });

    this.updateDrawerButtons(drawer, name);

    const items = Array.from(this.colorGridEl.children).filter(c => c.hasAttribute('data-color-item'));
    const idx = items.indexOf(item);
    const rowEnd = Math.min(Math.floor(idx / 3) * 3 + 2, items.length - 1);
    const anchorItem = items[rowEnd];

    anchorItem.after(drawer);
    this.mobileDrawer = drawer;
  }

  updateDrawerButtons(drawer, name) {
    const target = this.bundleConfig[this.state.bundle].target;
    const total = this.getTotal();
    const qty = this.state.quantities[name];

    const item = this.colorItems.find((el) => el.getAttribute('data-color-name') === name);
    const sizeAttr = `data-available-${this.state.size}`;
    const isAvailable = item && item.getAttribute(sizeAttr) === 'true';
    const maxQty = this.getMaxForColor(name);

    drawer.querySelector('[data-drawer-minus]').disabled = qty <= 0;
    drawer.querySelector('[data-drawer-plus]').disabled = total >= target || !isAvailable || qty >= maxQty;
  }

  attemptSwitchBundle(key) {
    const newTarget = this.bundleConfig[key].target;
    const total = this.getTotal();

    if (total > newTarget) {
      this.showBundleWarning(key, newTarget);
      return;
    }

    this.hideBundleWarning();
    this.switchBundle(key);
  }

 showBundleWarning(key, target) {
    this.pendingBundleKey = key;
    if (!this.bundleWarningEl) return;
    this.updateBundleWarningMessage(target);
    this.bundleWarningEl.hidden = false;
  }

  updateBundleWarningMessage(target) {
    if (!this.bundleWarningMessageEl) return;
    const current = this.getTotal();
    const excess = Math.max(current - target, 0);
    const message = this.translations.bundleWarning
      .replace('[CURRENT]', current)
      .replace('[EXCESS]', excess)
      .replace('[TARGET]', target);
    this.bundleWarningMessageEl.textContent = message;
  }

  hideBundleWarning() {
    this.pendingBundleKey = null;
    if (this.bundleWarningEl) this.bundleWarningEl.hidden = true;
  }

  buildProgressSegments() {
    const target = this.bundleConfig[this.state.bundle].target;
    this.progressBarEl.innerHTML = '';
    for (let i = 0; i < target; i++) {
      const seg = document.createElement('span');
      seg.className = 'pick-and-mix__progress-segment';
      if (i === target - 1) {
        seg.classList.add('pick-and-mix__progress-segment--gift');
        seg.innerHTML = `
          <svg class="pick-and-mix__gift-icon" width="12" height="12" viewBox="0 0 24 24" fill="red" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="20 12 20 22 4 22 4 12"></polyline>
            <rect x="2" y="7" width="20" height="5"></rect>
            <line x1="12" y1="22" x2="12" y2="7"></line>
            <path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"></path>
            <path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"></path>
          </svg>
        `;
      }
      this.progressBarEl.appendChild(seg);
    }
  }
  setupStickyObserver() {
    if (!this.stickySentinelEl || !this.progressHolderEl) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        this.progressHolderEl.classList.toggle('is-stuck', !entry.isIntersecting);
      },
      { threshold: 0, rootMargin: '-81px 0px 0px 0px' }
    );
    observer.observe(this.stickySentinelEl);
  }

  switchBundle(key) {
    this.state.bundle = key;

    this.bundleToggleEl.querySelectorAll('[data-bundle-option]').forEach((btn) => {
      btn.classList.toggle('is-active', btn.getAttribute('data-bundle-option') === key);
    });

    this.querySelectorAll('[data-media-for]').forEach((el) => {
      el.classList.toggle('is-active', el.getAttribute('data-media-for') === key);
    });

    this.buildProgressSegments();
    this.render();
    this.updateDynamicDiscountLabels();
    this.updateBundleLabels();
  }

  switchSize(size) {
    this.state.size = size;

    this.sizeToggleEl.querySelectorAll('[data-size-option]').forEach((btn) => {
      btn.classList.toggle('is-active', btn.getAttribute('data-size-option') === size);
    });

    const label = size === '50x100' ? '50x100 cm' : '70x140 cm';
    this.querySelectorAll('[data-color-size-label]').forEach((el) => {
      el.textContent = label;
    });

    // Clear quantities for any color that isn't available at the newly selected size
   const sizeAttr = `data-available-${size}`;
    this.colorItems.forEach((item) => {
      const name = item.getAttribute('data-color-name');
      const isAvailable = item.getAttribute(sizeAttr) === 'true';
      if (!isAvailable) {
        this.state.quantities[name] = 0;
        return;
      }
      const maxAttr = `data-max-${size}`;
      const maxQty = parseInt(item.getAttribute(maxAttr) || '9999', 10);
      if (this.state.quantities[name] > maxQty) {
        this.state.quantities[name] = maxQty;
      }
    });

    this.render();
    this.updateDynamicDiscountLabels();
    this.updateBundleLabels('5-1');
    this.updateBundleLabels('8-4');
  }

  resetQuantities() {
    Object.keys(this.state.quantities).forEach((name) => {
      this.state.quantities[name] = 0;
    });
    this.colorItems.forEach((item) => {
      item.querySelector('[data-stepper-value]').textContent = '0';
    });
  }

  changeQuantity(name, delta) {
    const target = this.bundleConfig[this.state.bundle].target;
    const total = this.getTotal();

    if (delta > 0) {
      const item = this.colorItems.find((el) => el.getAttribute('data-color-name') === name);
      const sizeAttr = `data-available-${this.state.size}`;
      const isAvailable = item && item.getAttribute(sizeAttr) === 'true';
      if (!isAvailable) return;

      const maxQty = this.getMaxForColor(name);
      if (this.state.quantities[name] >= maxQty) return; // stock cap reached

      if (total >= target) return; // bundle cap reached
    }
    if (delta < 0 && this.state.quantities[name] <= 0) return;

    this.state.quantities[name] += delta;
    this.render();
  }

  getMaxForColor(name) {
    const item = this.colorItems.find((el) => el.getAttribute('data-color-name') === name);
    if (!item) return 0;
    const maxAttr = `data-max-${this.state.size}`;
    const raw = item.getAttribute(maxAttr);
    return raw ? parseInt(raw, 10) : 12;
  }

  getTotal() {
    return Object.values(this.state.quantities).reduce((sum, q) => sum + q, 0);
  }

  getCurrentBundleData() {
    return this.priceData[this.state.bundle]?.[this.state.size];
  }

  getUnitPrice() {
    const data = this.getCurrentBundleData();
    const target = this.bundleConfig[this.state.bundle].target;
    return data && data.price && target ? data.price / target : 0;
  }
  getFullUnitPrice() {
    const data = this.getCurrentBundleData();
    const target = this.bundleConfig[this.state.bundle].target;
    if (data && data.compareAtPrice && target) {
      return data.compareAtPrice / target;
    }
    return this.getUnitPrice();
  }
  updateBundleLabels(key = this.state.bundle) {
    const data = this.priceData[key]?.[this.state.size];
    const target = this.bundleConfig[key].target;
    if (!data || !data.price || !target) return;
    const unitPrice = data.price / target;
    const priceEl = this.querySelector(`[data-bundle-price="${key}"]`);
    if (priceEl) priceEl.textContent = this.formatMoney(unitPrice);

    const totalEl = this.querySelector(`[data-bundle-total="${key}"]`);
    if (totalEl) totalEl.textContent = this.formatMoney(data.price);

    const compareEl = this.querySelector(`[data-bundle-compare="${key}"]`);
    if (compareEl) {
      const hasDiscount = data.compareAtPrice && data.compareAtPrice > data.price;
      compareEl.hidden = !hasDiscount;
      if (hasDiscount) compareEl.textContent = this.formatMoney(data.compareAtPrice);
    }
  }

  formatMoney(cents) {
    const value = (cents / 100).toFixed(2).replace('.', ',');
    return `${value}`;
  }

 render() {
    if (this.pendingBundleKey && this.bundleWarningEl && !this.bundleWarningEl.hidden) {
      const pendingTarget = this.bundleConfig[this.pendingBundleKey].target;
      if (this.getTotal() <= pendingTarget) {
        this.hideBundleWarning();
      } else {
        this.updateBundleWarningMessage(pendingTarget);
      }
    }

    const target = this.bundleConfig[this.state.bundle].target;
    const free = this.bundleConfig[this.state.bundle].free;
    const total = this.getTotal();
    const unitPrice = this.getUnitPrice();

    // Stepper values + plus-button disable state
    this.colorItems.forEach((item) => {
      const name = item.getAttribute('data-color-name');
      const qty = this.state.quantities[name];
      item.querySelector('[data-stepper-value]').textContent = qty;

      const sizeAttr = `data-available-${this.state.size}`;
      const isAvailable = item.getAttribute(sizeAttr) === 'true';
      item.classList.toggle('is-unavailable', !isAvailable);

      const maxQty = this.getMaxForColor(name);
      const plusBtn = item.querySelector('[data-stepper-plus]');
      plusBtn.disabled = total >= target || !isAvailable || qty >= maxQty;

      const minusBtn = item.querySelector('[data-stepper-minus]');
      minusBtn.disabled = qty <= 0;
    });

    // Progress bar
    this.progressCountEl.textContent = `${total} ${this.translations.of} ${target}`;
    const segments = this.progressBarEl.querySelectorAll('.pick-and-mix__progress-segment');
    segments.forEach((seg, i) => {
      seg.classList.toggle('is-filled', i < total);
    });

    const remaining = Math.max(target - total, 0);
    if (remaining === 0) {
      this.progressHintEl.classList.add('is-complete');
      this.progressHintEl.innerHTML = `<strong>${this.translations.completeHint}</strong>`;
    } else {
      this.progressHintEl.classList.remove('is-complete');
      const unitForms = this.translations.remainingUnits[this.state.size] || this.translations.remainingUnits['50x100'];
      const unitWord = remaining === 1 ? unitForms.singular : unitForms.plural;
      this.progressHintEl.innerHTML = this.translations.remainingHint.replace(
        '[COUNT]',
        `<strong data-hint-remaining style="color:#6E2A6E">${remaining} ${unitWord}</strong>`
      );
    }

    // Summary
    if (total > 0) {
      this.summaryEl.hidden = false;

      this.summaryLinesEl.innerHTML = '';
      Object.entries(this.state.quantities)
        .filter(([, qty]) => qty > 0)
        .forEach(([name, qty]) => {
          const item = this.colorItems.find((el) => el.getAttribute('data-color-name') === name);
          const swatchColor = item ? item.getAttribute('data-color-swatch') : '#000';
          const sizeLabel = this.state.size === '50x100' ? '50x100 cm' : '70x140 cm';
          const lineTotal = unitPrice * qty;

          const row = document.createElement('div');
          row.className = 'pick-and-mix__summary-line';
          row.innerHTML = `
            <span class="pick-and-mix__summary-line-swatch" style="background-image:url('${swatchColor}'); background-size:cover;"></span>
            <span class="pick-and-mix__summary-line-name">${name} <small>${sizeLabel}</small></span>
            <span class="pick-and-mix__summary-line-qty">${qty}x</span>
            <span class="pick-and-mix__summary-line-price">${this.formatMoney(lineTotal)}</span>
          `;
          this.summaryLinesEl.appendChild(row);
        });

      const subtotal = unitPrice * total;
      this.summarySubtotalEl.textContent = this.formatMoney(subtotal);

      // Translate 'Subtotaal' row header
      const subtotalRowSpan = this.summarySubtotalEl.previousElementSibling;
      if (subtotalRowSpan) subtotalRowSpan.textContent = this.translations.subtotal;

      // if (total === target) {
      //   const bundlePrice = this.getCurrentBundleData()?.price || 0;
      //   const discountValue = subtotal - bundlePrice;
      //   this.summaryDiscountRowEl.style.display = 'flex';
      //   this.summaryDiscountLabelEl.textContent = `${free} ${this.translations.free}`;
      //   this.summaryDiscountValueEl.textContent = `-${this.formatMoney(discountValue)}`;
      //   this.summaryTotalEl.textContent = this.formatMoney(bundlePrice);
      // } else {
      //   this.summaryDiscountRowEl.style.display = 'none';
      //   this.summaryTotalEl.textContent = this.formatMoney(subtotal);
      // }
      this.summaryDiscountRowEl.style.display = 'none';
      this.summaryTotalEl.textContent = this.formatMoney(subtotal);

      if (this.summaryTotalCompareEl) {
        const compareSubtotal = this.getFullUnitPrice() * total;
        if (compareSubtotal > subtotal) {
          this.summaryTotalCompareEl.textContent = this.formatMoney(compareSubtotal);
          this.summaryTotalCompareEl.hidden = false;
        } else {
          this.summaryTotalCompareEl.hidden = true;
        }
      }
    } else {
      this.summaryEl.hidden = true;
    }

    // Add to cart button state — only enabled once the set is complete
    this.addToCartBtn.disabled = total !== target;
  }
 addToCart() {
    console.log('[DEBUG] addToCart() called. Call stack:', new Error().stack);

    const total = this.getTotal();
    console.log('[DEBUG] total:', total, 'state:', JSON.stringify(this.state));

    const target = this.bundleConfig[this.state.bundle].target;
    if (total !== target) return;

    const attrName = `data-variant-id-${this.state.size}`;
    const bundleSessionId = `bundle-${this.state.bundle}-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;

    const items = this.colorItems
      .map((item) => {
        const name = item.getAttribute('data-color-name');
        const qty = this.state.quantities[name];
        const variantIdRaw = item.getAttribute(attrName);
        const variantId = variantIdRaw ? parseInt(variantIdRaw, 10) : null;
        return qty > 0 && variantId
        ? {
            id: variantId,
            quantity: qty,
            properties: {
              _pick_and_mix: 'true', 
            },
          }
        : null;
      })
      .filter(Boolean);

    console.log('[DEBUG] items being sent:', items);

    if (!items.length) {
      this.showError(this.translations.errorMsg);
      return;
    }

    const payload = { items };
    console.log('[DEBUG] payload being sent:', JSON.stringify(payload));

    this.addToCartBtn.disabled = true;
    this.addToCartSpinner.hidden = false;
    this.addToCartText.textContent = this.translations.adding;
    this.hideError();

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    })
      .then((res) => {
        console.log('[DEBUG] response status:', res.status);
        return res.json();
      })
      .then((data) => {
  if (data.status) {
    throw new Error(data.description || 'Er ging iets mis.');
  }

  // Refresh cart sections then open the drawer
  const cartItemsEl = document.getElementById('cart-items');
  const sectionId = cartItemsEl ? cartItemsEl.dataset.id : null;

  const openDrawer = () => {
    const drawerTrigger = document.querySelector('[aria-controls="cart-drawer"]');
    if (drawerTrigger) drawerTrigger.click();
  };

  if (sectionId) {
    fetch(`/?sections=${sectionId},cart-item-counter`)
      .then((r) => r.json())
      .then((sections) => {
        try {
          const parser = new DOMParser();
          const parsed = parser.parseFromString(sections[sectionId], 'text/html');

          const el1 = document.querySelector('#cart-items');
          const new1 = parsed.querySelector('#cart-items');
          if (el1 && new1) el1.innerHTML = new1.innerHTML;

          const el2 = document.querySelector('#cart-summary');
          const new2 = parsed.querySelector('#cart-summary');
          if (el2 && new2) el2.innerHTML = new2.innerHTML;

          if (sections['cart-item-counter']) {
            const counterEl = document.querySelector('#cart-item-counter');
            const parsedCounter = parser.parseFromString(sections['cart-item-counter'], 'text/html');
            const newCounter = parsedCounter.querySelector('#cart-item-counter');
            if (counterEl && newCounter) counterEl.innerHTML = newCounter.innerHTML;
          }
        } catch (e) {
          console.log('[DEBUG] section refresh error:', e);
        }
        openDrawer();
      })
      .catch(() => openDrawer());
  } else {
    openDrawer();
  }

  this.addToCartText.textContent = this.translations.added;
  setTimeout(() => {
    this.addToCartText.textContent = this.translations.addToCart;
    const currentTarget = this.bundleConfig[this.state.bundle].target;
    this.addToCartBtn.disabled = this.getTotal() !== currentTarget;
  }, 1500);
})
      .catch((err) => {
        console.log('[DEBUG] catch error:', err);
        this.showError(err.message || this.translations.errorMsg);
        this.addToCartBtn.disabled = false;
        this.addToCartText.textContent = this.translations.addToCart;
      })
      .finally(() => {
        this.addToCartSpinner.hidden = true;
      });
  }

  showError(message) {
    this.errorMessage.textContent = message;
    this.errorHolder.hidden = false;
    this.errorHolder.setAttribute('aria-hidden', 'false');
  }

  hideError() {
    this.errorHolder.hidden = true;
    this.errorHolder.setAttribute('aria-hidden', 'true');
  }
  
  updateDynamicDiscountLabels() {
    // Loop through both bundle options to update their badges dynamically
    ['5-1', '8-4'].forEach(bundleKey => {
      const data = this.priceData[bundleKey]?.[this.state.size];
      if (!data) return;

      const discountCents = data.compareAtPrice - data.price;
      if (discountCents <= 0) return;

      const valueFormatted = (discountCents / 100).toFixed(0);
      
      // Auto-translate the label suffix based on store language
      let labelSuffix = 'Korting';
      if (document.documentElement.lang.includes('en')) {
        labelSuffix = 'Discount';
      } else if (document.documentElement.lang.includes('de')) {
        labelSuffix = 'Rabatt';
      }

      // Generates the correct spacing: "€ 36 Korting"
      const discountText = `€ ${valueFormatted} ${labelSuffix}`;

      // Locate the active media section and swap the label content
      const mediaInstance = document.querySelector(`[data-media-for="${bundleKey}"]`);
      if (mediaInstance) {
        const discountBtn = mediaInstance.querySelector('.js-dynamic-discount-label');
        if (discountBtn) {
          discountBtn.textContent = discountText;
        }
      }
    });
  }
}

customElements.get('pick-and-mix-app') === undefined && customElements.define('pick-and-mix-app', PickAndMixApp);